'use client';

export type {
  UrlListener,
  UrlListenerOptions,
  UrlListenerAdapter,
  UrlListenerEventItem,
} from './types/urlListener';

export {
  createUrlListener,
  createNoopUrlListener,
  getUrlListener,
  mergeUrlListenerAdapter,
  resetUrlListenerAdapter,
  defaultBrowserUrlListenerAdapter,
} from './core/urlListenerRegistry';
